import React, { Component } from "react";

export default class RoomRugMobileFilterSizes extends Component {

  render() {
    return (
      <ul className="three-child-body active">
        <li className="three-child">
          <span>{this.props.texts["rug_size_6"]}</span>
        </li>
        <li className="three-child">
          <span>{this.props.texts["rug_size_9"]}</span>
        </li>
        <li className="three-child">
          <span>{this.props.texts["rug_size_12"]}</span>
        </li>
      </ul>
    );
  }
}
